import React, { useCallback } from 'react';

import { Input } from 'antd';

import { useFormikContext } from 'formik';
import { Hint } from 'v2/components/Shared/Hint';
import moneyNoSymbolMask from 'v2/components/Shared/Masks/moneyNoSymbol';

type CurrencyFormFieldProps = {
  [key: string]: any;
  id?: string;
  name?: string;
  helperText?: React.ReactNode;
  currency?: string;
  prefix?: React.ReactNode;
  InputProps?: any;
  inputProps?: any;
};

const CurrencyFormField = ({
  helperText,
  name,
  currency = 'BRL',
  prefix,
  InputProps,
  inputProps,
  ...props
}: CurrencyFormFieldProps) => {
  const { getFieldMeta, setFieldValue, setFieldTouched } = useFormikContext();
  const meta = getFieldMeta<number>(name);
  const errorText = meta.touched && meta.error;
  const maskedValue = moneyNoSymbolMask.apply(meta.value, currency);

  const onChangeHandler = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      return setFieldValue(name, moneyNoSymbolMask.clean(e.target.value, currency));
    },
    [setFieldValue, name, currency]
  );

  const onBlurHandler = useCallback(() => {
    setFieldTouched(name, true);
  }, [setFieldTouched, name]);

  const addonPrefix = prefix || InputProps?.startAdornment?.props?.children;

  return (
    <Hint inputName={name}>
      <div className='w-full'>
        <Input
          id={props.id}
          prefix={addonPrefix}
          status={errorText ? 'error' : undefined}
          name={name}
          value={maskedValue}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
          {...inputProps}
        />
        {(errorText || helperText) && (
          <p className={`mt-1 text-xs ${errorText ? 'text-red-500' : 'text-gray-500'}`}>{errorText || helperText}</p>
        )}
      </div>
    </Hint>
  );
};

export default CurrencyFormField;
